import type { BpaRowFormValues } from "../schemas/manageFormSchemas";
import type { BpaRow } from "./bpaRows";
import type { EditionBpaBulkAssignRequest } from "../../../../api/researchCms.service";

export function buildBulkAssignPayload(
  formRows: BpaRowFormValues[],
  serverRows: BpaRow[],
  editionBpaIdByBpaId: Map<string, string>,
): EditionBpaBulkAssignRequest | null {
  const serverRowById = new Map(serverRows.map(row => [row.id, row]));
  const assignments: EditionBpaBulkAssignRequest["assignments"] = [];

  for (const formRow of formRows) {
    const serverRow = serverRowById.get(formRow.id);
    if (!serverRow) continue;

    const editionBpaId = editionBpaIdByBpaId.get(formRow.id);
    if (!editionBpaId) continue;

    const researcherChanged = formRow.assignedResearcherId !== serverRow.assignedResearcherId;
    const editorChanged = formRow.assignedEditorId !== serverRow.assignedEditorId;
    if (!researcherChanged && !editorChanged) continue;

    assignments.push({
      editionBpaId,
      ...(researcherChanged ? { assignedResearcherId: formRow.assignedResearcherId } : {}),
      ...(editorChanged ? { assignedEditorId: formRow.assignedEditorId } : {}),
    });
  }

  if (assignments.length === 0) return null;

  return { assignments };
}
